import React from 'react';
import { X, Check, Printer } from 'lucide-react';
import { fmtMoneda } from '../utils/moneda';
import { fmtFecha } from '../utils/fecha';
import { imprimirReciboCobro } from '../utils/reciboCobro';

// Modal de éxito tras confirmar un pago EN OFICINA: muestra el número de recibo
// que asignó el sistema y ofrece imprimir el recibo del cliente.
export default function ReciboCobroExito({ datos, onClose }) {
  if (!datos) return null;
  return (
    <div className="modal-overlay" style={{ zIndex: 1500 }} onClick={onClose}>
      <div className="modal" style={{ maxWidth: 420 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 34, height: 34, borderRadius: '50%', background: 'rgba(34, 197, 94, 0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Check size={18} style={{ color: 'var(--text-success)' }} />
            </div>
            <div>
              <div className="modal-title">Pago registrado</div>
              <div style={{ fontSize: 12, color: 'var(--silver)', marginTop: 2 }}>
                {datos.polizaNum} · {datos.cliente}
              </div>
            </div>
          </div>
          <button className="btn btn-icon btn-secondary btn-sm" onClick={onClose}><X size={16} /></button>
        </div>
        <div className="modal-body">
          <div style={{ background: 'rgba(var(--sky-rgb),0.1)', borderRadius: 8, padding: '12px 16px', marginBottom: 14, border: '1px solid rgba(var(--sky-rgb),0.25)', textAlign: 'center' }}>
            <div style={{ fontSize: 11, color: 'var(--silver)', marginBottom: 4, textTransform: 'uppercase', letterSpacing: 1 }}>N° de recibo asignado</div>
            <div style={{ fontSize: 22, fontWeight: 800, color: 'var(--sky-light)', fontFamily: 'monospace' }}>{datos.numRecibo}</div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: 'var(--silver)', padding: '0 4px' }}>
            <span>Monto: <strong style={{ color: 'var(--text-success)' }}>{fmtMoneda(datos.monto)}</strong></span>
            <span>{fmtFecha(datos.fecha)}</span>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
          <button className="btn btn-primary" onClick={() => imprimirReciboCobro(datos)}>
            <Printer size={14} /> Imprimir recibo
          </button>
        </div>
      </div>
    </div>
  );
}
